import Vue from 'vue';
import VueRouter from 'vue-router';
import routes from './routes';
import NotFound from '../components/NoFound';
import { isWechat, isIOS } from 'utils';
import { hideOptionMenu, share } from 'utils/wx';
import config from 'config';
import { addRouteAnalytics } from 'utils/analytics';
import omit from 'lodash/omit';

const _import = (file) => require('module/' + file + '.vue').default;
Vue.use(VueRouter);

const router = new VueRouter({
  mode: 'history',
  routes: [
    ...routes,
    {
      path: '/',
      component: _import('member/login/page'),
      props: (route) => ({ params: { ...route.query } })
    },
    { path: '*', component: NotFound }
  ],
  scrollBehavior(to, from, savedPosition) {
    if (to.hash) {
      return {
        selector: to.hash
      };
    }
    if (savedPosition) {
      return savedPosition;
    } else {
      return {
        x: 0,
        y: 0
      };
    }
  }
});

router.beforeEach((to, from, next) => {
  console.log('[route][to] beforeEach-------------> ', to.fullPath);
  console.log('[route][from] beforeEach-----------> ', from.fullPath);

  // 全局路径添加商家编码，添加是否平台
  if (to && to.params) {
    // if (!to.query.hasOwnProperty('app_params')) {
    //   if (to.query.hasOwnProperty('is_platform')) {
    //     G.is_platform = to.query.is_platform;
    //     console.log('set G.is_platform 1======== > ', G.is_platform, G.member);
    //     next();
    //   } else {
    //     G.is_platform = from.query.is_platform || 0;
    //     console.log('set G.is_platform 2======== > ', G.is_platform, G.member);
    //     next({
    //       ...to,
    //       query: {
    //         ...to.query,
    //         is_platform: G.is_platform
    //       }
    //     });
    //   }
    // } else {
    //   if (to.query.hasOwnProperty('member')) {
    //     G.member = JSON.parse(to.query.member || '{}');
    //   }
    //   const appParams = JSON.parse(to.query.app_params || '{}') || {};
    //   next({
    //     ...to,
    //     query: {
    //       ...omit({...to.query, ...appParams}, ['member', 'app_params'])
    //     }
    //   });
    // }
    if (to.query.hasOwnProperty('app_params') || !to.query.hasOwnProperty('is_platform')) {
      // 小程序传递用户信息到h5 member:Object (包含enterprise、token)
      if (to.query.hasOwnProperty('member')) {
        G.member = JSON.parse(to.query.member || '{}');
      }
      // 小程序传递业务数据到h5 app_params:Object (包含各种id)
      const appParams = JSON.parse(to.query.app_params || '{}') || {};
      console.log('to.params ------ ', JSON.parse(to.query.member || '{}'), appParams);
      console.log('set G.is_platform 1======== > ', G.is_platform, G.member);
      G.is_platform = from.query.is_platform || to.query.is_platform || 0;
      next({
        ...to,
        query: {
          ...omit({...to.query, ...appParams}, ['member', 'app_params']),
          is_platform: G.is_platform
        },
        replace: true
      });
    } else {
      console.log('set G.is_platform 2======== > ', G.is_platform, G.member);
      next();
    }
  }

  // const wechat = isWechat();
  // 路径或参数中带商家编码, 从localStorage中取出登陆信息，设置全局G.enterprise、G.member
  if ((to.params && to.params.enterprise) || (to.query && to.query.enterprise)) {
    G.enterprise = to.params.enterprise || to.query.enterprise;
    console.log('-----路径中带商家编码-----', G.enterprise);
    if ((!G.member || (G.member && !G.member.token)) && G.enterprise) {
      G.member = JSON.parse(localStorage.getItem(G.enterprise) || '{}');
      console.log('-----设置G.member-----', G.member);
    }
  }

  // 权限校验
  if (to.matched.some((record) => record.meta.auth)) {
    if (!G.member || !G.member.token) {
      next({
        path: '/login',
        query: {
          enterprise: G.enterprise,
          redirect: encodeURIComponent(to.route.fullPath)
        }
      });
    }
  }

  next();
});

router.afterEach((to, from) => {
  addRouteAnalytics(to, from);
  // console.log('[route][to] afterEach-------------> ', to.fullPath)
  // console.log('[route][from] afterEach -----------> ', from.fullPath)
  if (!to.matched.some((record) => record.meta.canShare)) {
    if (isWechat()) {
      hideOptionMenu(to);
    }
  }
});

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js